import React, { Fragment, useEffect, useState } from 'react';
import CustomerSearchResult from './CustomerSearchResult';
import * as debounce from 'lodash.debounce';
import { translate } from '../../../../Services/translation';
import { get } from '../../../../Services/http';
import { BACKEND_LOGGEND_IN_SHOPID } from '../../../Services/Api.service';
import { isEcomAdmin } from '../../../Services/Api.service';

const Search = () => {
    const [searchResults, setsearchResults] = useState([]);
    const [displayResult, setdisplayResult] = useState(false);
    const [searchText, setsearchText] = useState('');    

    const queryCustomer = (q) => {
        // abort any existing, pending request.
        // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.         
        return get(`/api/customer/search/${q}`)
            .then((response) => response.json())
            .then((result) => {
                setsearchResults(isEcomAdmin() ? result : result.filter(x => x.nearestOptician === localStorage.getItem(BACKEND_LOGGEND_IN_SHOPID)));
                setdisplayResult(true);                
            })
            .catch((ex) => console.log('error'));
    };
        
    const onKeyDown = (event, opt) => {
        
    }
    const onClose = () => {
        setdisplayResult(false);
        setsearchResults([]);
    }

    const debouncedQuery = debounce((text) => queryCustomer(text));

    const onSearch = (text) => {  
        setsearchText(text);
        if (text.length > 2) {
            debouncedQuery(text);
        }        
    }                  
        

        return (
            <Fragment>
                <div className='admin-portal__customer-search'>
                    <h2 className='title'>{translate("coptikk.adminportal.customer.header")}</h2>
                    <div className='search-wrapper'>
                        <div className="quick-search" role="search">
                            <div className={`quick-search__form quick-search__form--force-show ${searchText ? 'quick-search__not-empty' : ''}`} role="search">
                                <input className="quick-search__input" type="search" placeholder={translate("coptikk.adminportal.customer.search.placeholder")}
                                    autoComplete="off" value={searchText} onChange={event => onSearch(event.target.value)}                        
                                />
                                {searchText ? <i className="quick-search__icon-close" onClick={() => onSearch("")}></i> : undefined}
                                <i className="quick-search__icon" onClick={() => onKeyDown({ keyCode }, { searchUrl })}></i>
                                {displayResult &&
                                    <CustomerSearchResult result={searchResults}
                                        query={searchText}
                                        onClose={onClose} />}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>            
        )    
}

export default Search;